/** @format */

import React from 'react'
import { _$, Card } from 'kpc-react' // , Tabs, Tab
import MonitorCrumb from 'src/components/MonitorCrumb'
import Customboard from './Customboard'
// import Cloudboard from './Cloudboard'

const DashboardList: React.FC<any> = () => {
  // const [tabValue, setTabValue] = useState<'customboar' | 'cloudboard'>('customboar')
  return (
    <div>
      <MonitorCrumb breadArr={[{ title: _$('Dashboard') }]} />
      <Card>
        {/* <Tabs value={tabValue} on$change-value={(c, tab) => setTabValue(tab)}>
          <Tab value="customboar">自定义Dashboard</Tab>
          <Tab disabled={true} value="cloudboard">
            云产品Dashboard
          </Tab>
        </Tabs>
        <div className="marginTop">
          <>
            {tabValue === 'customboar' && <Customboard />}
            {tabValue === 'cloudboard' && <Cloudboard />}
          </>
        </div> */}
        <Customboard />
      </Card>
    </div>
  )
}

export default DashboardList
